export const mergeOrder = (order: readonly string[], current: readonly string[]): string[] => {
  const merged = [...order];
  current.forEach((key, index) => {
    if (merged.includes(key)) return;
    const next = current.slice(index + 1).find((candidate) => merged.includes(candidate));
    if (next === undefined) {
      merged.push(key);
      return;
    }
    merged.splice(merged.indexOf(next), 0, key);
  });
  return merged;
};

export const restoreIndex = (
  order: readonly string[],
  current: readonly string[],
  key: string,
): number => {
  const preceding = order.slice(0, Math.max(0, order.indexOf(key)));
  const anchor = [...preceding].reverse().find((candidate) => current.includes(candidate));
  return anchor === undefined ? 0 : current.indexOf(anchor) + 1;
};
